import { create } from 'zustand';
import { type User } from '@entities/user';

interface UserStore {
  users: User[];
  currentUser: User | null;
  setUsers: (users: User[]) => void;
  addUser: (user: User) => void;
  updateUser: (id: string, user: Partial<User>) => void;
  deleteUser: (id: string) => void;
  setCurrentUser: (user: User | null) => void;
  getUsersByTenant: (tenantId: string) => User[];
}

export const useUserStore = create<UserStore>((set, get) => ({
  users: [],
  currentUser: null,
  setUsers: (users) => set({ users }),
  addUser: (user) => set((state) => ({ users: [...state.users, user] })),
  updateUser: (id, updatedUser) =>
    set((state) => ({
      users: state.users.map((u) => (u.id === id ? { ...u, ...updatedUser } : u)),
    })),
  deleteUser: (id) => set((state) => ({ users: state.users.filter((u) => u.id !== id) })),
  setCurrentUser: (user) => set({ currentUser: user }),
  getUsersByTenant: (tenantId) => get().users.filter((u) => u.tenant_id === tenantId),
}));
